import React, { useEffect } from 'react'
import Page from 'src/components/Page'
import { makeStyles } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { selectUserInfo } from 'src/app/slices/userSlice'
import {
  getAllExams, selectorAllExams,
  getUserExams, selectorExam,
  //  getSearchExam,
} from '../../app/slices/examSlice'
import DiscQuizCard from './DiscQuizCard'

const useStyles = makeStyles(() => ({
  root: {
    padding: 10,
    borderRadius: '20px',
    // width: '90%',
    '&.MuiPaper-root': {
    },
    '@media (max-width: 970px)': {
      padding: 2,
    },
  },
}))

function DiscTest() {
  const classes = useStyles()
  const exams = useSelector(selectorAllExams)
  const userExams = useSelector(selectorExam)
  const { role } = useSelector(selectUserInfo)
  const { examId } = useParams()
  const dispatch = useDispatch()

  const getDiscs = exams?.filter((item) => item.exam.id === 2)

  useEffect(() => {
    if (role?.roleId === 1) {
      dispatch(getUserExams({ after: '0', first: '100', userExamId: examId }))
      // dispatch(getSearchExam())
    } else {
      dispatch(getAllExams())
      // dispatch(getSearchExam())
    }
  }, [])

  return (
    <Page
      className={classes.root}
      title="فهرست پکیج ها"
    >
      <DiscQuizCard discs={role?.roleId === 1 ? userExams : getDiscs} />
    </Page>
  )
}

export default DiscTest
